import Joi from '@hapi/joi'

export const PurchaseAdviceSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID:  Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Select Company `,
        "any.required": `Company required`
    })
}

export const PurchaseAdviceAddEditObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group `,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Select Company `,
        "any.required": `Company required`
    }),
    invoiceDate: Joi.string().isoDate().required().label("Invoice Date"),
    dueDate: Joi.string().isoDate().required().label("Due Date"),
    buyerID: Joi.number().invalid(0).required().label("Buyer").messages({
        "any.invalid": `Select Buyer`,
        "any.required": `Buyer required`
    }),
    statusTypeID: Joi.number().allow("", null)
}

export const OrderItemAddEditObject = {
    collectionTypeID: Joi.number().invalid(0).required().label("Item").messages({
        "any.invalid": `Select Item `,
        "any.required": `Item required`
    }),
    measuringUnit: Joi.number().invalid(0).required().messages({
        "string.empty": `Measuring Unit required`,
        "any.required": `Measuring Unit required`,
        "any.invalid": `Measuring Unit required `,
    }),
    statusTypeID: Joi.number().allow("", null),
    price : Joi.number().positive().required().label("Price"),
    packageWeight : Joi.number().positive().required().label("Package Weight").messages({
        "number.base": `Package Weight should be a number`,
        "number.empty": `Package Weight field can’t be empty`
    }),
    totalPackagesStore : Joi.number().positive().required().label("Total Packages Store").messages({
        "number.base": `Total package should be a number`,
        "number.empty": `Total package store field can’t be empty`
    }),
    totalPackagesExport : Joi.number().positive().required().label("Total Packages Export").messages({
        "number.base": `Total package export should be a number`,
        "number.empty": `Total package export field can’t be empty`
    }),
    itemQuantity : Joi.string().allow("", null),
    maxAmount : Joi.string().allow("", null),
    aspNetUserId: Joi.number().invalid(0).required().label("User").messages({
        "any.invalid": `Select User`,
        "any.required": `User required`
    }),
}

export const OrderItemAddEditObjectForUnit = {
    collectionTypeID: Joi.number().invalid(0).required().label("Item").messages({
        "any.invalid": `Select Item `,
        "any.required": `Item required`
    }),
    measuringUnit: Joi.string().required().messages({
        "string.empty": `Measuring Unit required`,
        "any.required": `Measuring Unit required`,
        "any.invalid": `Measuring Unit required `,
    }),
    statusTypeID: Joi.number().allow("", null),
    price : Joi.number().positive().required().label("Price"),
    itemQuantity : Joi.number().positive().required().label("Exact Amount"),
    maxAmount : Joi.number().positive().required().label("Max Amount"),
    packageWeight : Joi.number().allow("", null),
    totalPackagesStore : Joi.number().positive().required().label("Total Packages Store").messages({
        "number.base": `Total package should be a number`,
        "number.empty": `Total package store field can’t be empty`
    }),
    totalPackagesExport : Joi.number().positive().required().label("Total Packages Export").messages({
        "number.base": `Total package export should be a number`,
        "number.empty": `Total package export field can’t be empty`
    }),
    itemQuantity : Joi.number().positive().required().label("Exact Amount").messages({
        "number.base": `Exact Amount field can’t be empty`,
        "number.empty": `Exact Amount field can’t be empty`
    }),
    maxAmount : Joi.number().positive().required().label("Max Amount").messages({
        "number.base": `Max Amount field can’t be empty`,
        "number.empty": `Max Amount field can’t be empty`
    }),
    aspNetUserId: Joi.number().invalid(0).required().label("User").messages({
        "any.invalid": `Select User`,
        "any.required": `User required`
    }),
}

export const UnitPriceUpdateObject = {
    newunitprice : Joi.number().positive().required().label("New Unit Price").messages({
        "number.positive": `Enter valid unit price`
    }),
}